import React from 'react';
import { useParams } from 'react-router-dom';
import data from '../projects/data.json';
import Seo from '../components/Seo';
import { FiGithub, FiExternalLink, FiGlobe, FiTwitter, FiLinkedin, FiYoutube, FiBook, FiShoppingBag } from 'react-icons/fi';
import { SiKickstarter, SiAmazon } from 'react-icons/si';

export default function ProjectDetail() {
  const { slug } = useParams();
  const all = [...(data.current || []), ...(data.previous || [])];
  const project = all.find(p => p.slug === slug);

  if (!project) {
    return <div style={{ padding: 40 }}>Project not found.</div>;
  }

  return (
    <article style={{ paddingTop: 32, paddingBottom: 32 }}>
      <Seo title={project.title} description={project.description} />
      {project.image ? (
        <img className="card-media" src={project.image} alt={project.title} style={{ height: 260 }} />
      ) : (
        <div className="card-media" style={{ height: 260 }} />
      )}
      <h1 style={{ marginTop: 16 }}>{project.title}</h1>
      <p className="card-desc" style={{ fontSize: 16 }}>{project.description}</p>
      {project.links && project.links.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <div className="section-title">Links</div>
          <div className="link-row">
            {project.links.map((l, idx) => {
              const url = String(l.href || '').toLowerCase();
              let icon = <FiExternalLink />;
              if (l.type === 'github') icon = <FiGithub />;
              else if (l.type === 'website') icon = <FiGlobe />;
              else if (l.type === 'twitter') icon = <FiTwitter />;
              else if (l.type === 'linkedin') icon = <FiLinkedin />;
              else if (l.type === 'youtube') icon = <FiYoutube />;
              else if (l.type === 'kickstarter') icon = <SiKickstarter />;
              else if (l.type === 'book') icon = <FiBook />;
              else if (l.type === 'product') icon = <FiShoppingBag />;
              else if (url.includes('github.com')) icon = <FiGithub />;
              else if (url.includes('kickstarter.com')) icon = <SiKickstarter />;
              else if (url.includes('amazon.')) icon = <SiAmazon />;
              else if (url.includes('goodreads.com') || url.includes('books.google') || url.includes('bookshop.org') || url.includes('leanpub.com')) icon = <FiBook />;
              else if (url.includes('twitter.com') || url.includes('x.com')) icon = <FiTwitter />;
              else if (url.includes('linkedin.com')) icon = <FiLinkedin />;
              else if (url.includes('youtube.com') || url.includes('youtu.be')) icon = <FiYoutube />;
              else if (url.includes('/dp/') || url.includes('/product/')) icon = <FiShoppingBag />;
              else if (url.startsWith('http')) icon = <FiGlobe />;
              return (
                <a key={idx} className="link-icon" href={l.href} target="_blank" rel="noreferrer" aria-label={l.label || l.href}>
                  {icon}
                </a>
              );
            })}
          </div>
        </div>
      )}
    </article>
  );
}


